export default ($resource) => {
    const apiUrl = `${SEED_CORE.ENV.API_URL}`;
    // the configured URL may end with a slash, "//index.php/..." does not match any bouncer route
    const url = `${SEED_CORE.ENV.ID_BOUNCER_URL}`.replace(/\/+$/, '');

    return $resource(url, null, {
        mobileIdStart: {
            method: 'GET',
            url: `${url}/mobileId/auth/start`
        },
        mobileIdFinish: {
            method: 'GET',
            url: `${url}/mobileId/auth/finish`
        },
        smartIdAuthenticate: {
            method: 'GET',
            url: `${url}/index.php/smartId/start`
        },
        idProfile: {
            method: 'POST',
            url: `${apiUrl}user/auth/login-id`
        },
        idCardChallenge: {
            method: 'GET',
            url: `${url}/index.php/estId/card/challenge`,
            withCredentials: true
        },
        idCardValidate: {
            method: 'POST',
            url: `${url}/index.php/estId/card/validate`,
            withCredentials: true
        },
        idCardLogout: {
            method: 'POST',
            url: `${url}/index.php/estId/card/logout`,
            withCredentials: true
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/IdBouncer/index.js